import { BaseInput, BaseInputProps } from "./base";
import { Label } from "../label";

export type NumberInputProps = Pick<
  BaseInputProps,
  | "label"
  | "disabled"
  | "value"
  | "error"
  | "mandatory"
  | "id"
  | "message"
  | "onBlur"
  | "dataTestId"
> & { onChange: (number: number | null) => void };

export const NumberInput = ({
  label,
  disabled,
  value,
  error,
  mandatory,
  id,
  message,
  onChange,
  onBlur,
  dataTestId,
}: NumberInputProps) => (
  <Label
    text={label}
    mandatory={mandatory}
    disabled={disabled}
    name={id}
    error={error}
    message={message}
  >
    <BaseInput
      id={id}
      name={id}
      maxLength={16}
      value={value?.toString().replace(/[^\d]/g, "") ?? ""}
      inputMode="numeric"
      pattern="\d*"
      onChange={(e) => {
        const asString = e.target.value.replace(/[^\d]/g, "");
        const asNumber = parseInt(asString, 10);

        onChange(Number.isNaN(asNumber) ? null : asNumber);
      }}
      onBlur={onBlur}
      disabled={disabled}
      dataTestId={dataTestId}
    />
  </Label>
);
